module.exports = __webpack_public_path__ + "img/Boton_facturacion.61228a87.png";